import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'

export type TPrePostFilterEmitterType = Extract<TEmitterType, 'pre-filter' | 'post-filter'>

export type TNonPrePostFilterEmitterType = Exclude<TEmitterType, TPrePostFilterEmitterType>

export const isPrePostFilterEmitterType = (
  emitterType: TEmitterType,
): emitterType is TPrePostFilterEmitterType => {
  return emitterType === 'pre-filter' || emitterType === 'post-filter'
}

export const withoutPrePostFilterEmitterTypes = (
  emitterTypes: TEmitterType[] | undefined,
): TNonPrePostFilterEmitterType[] => {
  return (emitterTypes ?? []).filter((emitterType) => !isPrePostFilterEmitterType(emitterType))
}
